import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';
import { MenuItem } from '../../models/menu-items..models';
import { MENU_ITEMS } from './app-menu';
import { UserModel } from '../../../users/models/users.model';
import { NgxPermissionsObject, NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: 'app-app-menu',
  standalone: false,
  templateUrl: './app-menu.component.html',
  styleUrl: './app-menu.component.scss'
})
export class AppMenuComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  currentUser: UserModel;
  menu: MenuItem[] = [];

  constructor(
    private authService: AuthService,
    private route: Router,
    private translateService: TranslateService,
    private permissionService: NgxPermissionsService
  ) { }

  async ngOnInit(): Promise<void> {
    this.translateService.onLangChange.subscribe(async () => {
      this.initMenuPermissions();
    })
    this.menu = MENU_ITEMS;
    this.menu.forEach(item => {
      if (item.data?.key) {
        item.title = this.translateService.instant(item.data.key);
      }
    });

    await this.authService.fetchCurrentUser();
    this.currentUser = this.authService.currentUser;
    this.initMenuPermissions();
  }

  initMenuPermissions() {
    this.menu = MENU_ITEMS.filter((x) => {
      return !x.data.permissions;
    });

    this.permissionService.permissions$.subscribe((permissions) => {
      this.menu = this.itemsWithPermission(permissions, MENU_ITEMS);
      this.translateMenuItems();
    });
  }
  itemsWithPermission(permissions: NgxPermissionsObject, menuItems: MenuItem[]) {
    return menuItems.filter((x) => {
      if (x.children?.length > 0)
        x.children = this.itemsWithPermission(permissions, x.children);

      return (!x.children || x.children.length > 0) &&
        (!x.data.permissions ||
          x.data.permissions.some((p) => permissions[p] !== undefined && permissions[p].name !== null));
    });
  }

  translateMenuItems() {
    this.menu.forEach((item) => {
      this.translateMenuItem(item);
    });
  }

  translateMenuItem(menuItem: MenuItem) {
    if (menuItem.children != null) {
      menuItem.children.forEach((item) => this.translateMenuItem(item));
    }
    if (menuItem.data !== undefined && menuItem.data.key !== undefined) {
      menuItem.title = this.translateService.instant(menuItem.data.key);
    }
  }

  logout(): void {
    this.authService.logout();
    this.route.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }
}
